import { useEffect, useState } from 'react';
import { Inter28 } from 'components/Atoms';
import {
  FilterByDaysWrapper,
  StatsWrapper,
  Stat,
  ListWrapper,
  ListFilters,
  ErrorCardContainer,
  ViewSelectorWrapper
} from './styles'
import { useTranslation, } from 'react-i18next';
import earningsIcon from 'assets/creators/stat/earnings.svg'
import followersIcon from 'assets/creators/stat/followers.svg'
import purchasesIcon from 'assets/creators/stat/purchases.svg'
import {
  FlixxCurrency,
  Magnifier
} from 'icons'
// import { dateFormat } from 'utils/common';
import {
  Input,
  ButtonSelector,
  ErrorCard,
  Seo,
  InputOld
} from 'ui';
import { ReactComponent as NoContentSVG } from 'assets/creators/states/no-content.svg'
import { ReactComponent as NoInternetSVG } from 'assets/creators/states/no-internet.svg'
import { ReactComponent as NoSearchResultsSVG } from 'assets/creators/states/no-search-results.svg'
import { ReactComponent as ServerErrorSVG } from 'assets/creators/states/server-error.svg'
import { useNetwork } from 'hooks';
import {
  useGetResume,
  useGetDetail
} from 'api/creator';
import { formatAmount } from 'utils/amounts';
import { ORDER } from 'config/constants';
import RowContent from './RowContent';
import { Table } from 'ui';
import RowSerie from './RowSerie';
import i18n from 'i18n';
import useFlags from 'hooks/useFlags';
import { normalize } from 'utils/strings/normalize';

const FIELD = {
  title: 'title',
  status: 'status',
  releaseDate: 'releaseDate',
  purchases: 'purchases',
  price: 'price',
  earnings: 'earnings',
}

const VIEW = {
  series: 'series',
  content: 'content',
}



const getContentHeaders = ({ length, field, direction, onClick }) => [
  {
    label: `${i18n.t('content')} (${length})`,
    isOrdered: true,
    order: field === FIELD.title ? direction : '',
    onClick: () => onClick(FIELD.title),
  }, {
    label: i18n.t('status'),
    isOrdered: true,
    order: field === FIELD.status ? direction : '',
    onClick: () => onClick(FIELD.status),
  }, {
    label: i18n.t('releaseDate'),
    isOrdered: true,
    order: field === FIELD.releaseDate ? direction : '',
    onClick: () => onClick(FIELD.releaseDate),
  }, {
    label: i18n.t('purchases'),
    isOrdered: true,
    order: field === FIELD.purchases ? direction : '',
    onClick: () => onClick(FIELD.purchases),
  }, {
    label: i18n.t('price'),
    isOrdered: true,
    order: field === FIELD.price ? direction : '',
    onClick: () => onClick(FIELD.price),
  }, {
    label: i18n.t('earnings'),
    isOrdered: true,
    order: field === FIELD.earnings ? direction : '',
    onClick: () => onClick(FIELD.earnings),
    tooltip: i18n.t('earningsTooltip')
  },
  {}
]

const getSeriesHeaders = ({ length, field, direction, onClick }) => [
  {
    label: `${i18n.t('series')} (${length})`,
    isOrdered: true,
    order: field === FIELD.title ? direction : '',
    onClick: () => onClick(FIELD.title),
  },
  {},
  {},
  {
    label: i18n.t('releaseDate'),
    isOrdered: true,
    order: field === FIELD.releaseDate ? direction : '',
    onClick: () => onClick(FIELD.releaseDate),
  }, {
    label: i18n.t('purchases'),
    isOrdered: true,
    order: field === FIELD.purchases ? direction : '',
    onClick: () => onClick(FIELD.purchases),
  }, {
    label: i18n.t('earnings'),
    isOrdered: true,
    order: field === FIELD.earnings ? direction : '',
    onClick: () => onClick(FIELD.earnings),
    tooltip: i18n.t('earningsTooltip')
  },
  {}
]


const Creators = () => {

  const { t, i18n } = useTranslation()


  const VIEW_OPTIONS = [
    { value: VIEW.series, label: 'Series' },
    { value: VIEW.content, label: t('allContent') },
  ]
  

  const [list, setList] = useState([])
  const [listSeries, setListSeries] = useState([])
  const [searchValue, setSearchValue] = useState('')
  const [orderField, setOrderField] = useState(FIELD.releaseDate)
  const [orderDirection, setOrderDirection] = useState(ORDER.desc)


  
  const [view, setView] = useState(
    () => VIEW_OPTIONS.find(opt => opt.value === VIEW.content)
  )

  const isSeriesView = view.value === VIEW.series


  const dateFormat = (date) => {
    const d = date ? new Date(date.replaceAll('Z', '')) : new Date()
    return new Intl.DateTimeFormat(i18n.language).format(d)
  }


  const PERIODS = {
    begin: {
      label: i18n.t('fromBeginning'),
      value: '',
      offset: 0,
      phrase: () => i18n.t('fromBeginningPhrase'),
    },
    month: {
      label: i18n.t('last30Days'),
      value: '30',
      offset: 1,
      phrase: (date) => i18n.t('periodPhrase', { start: date, end: dateFormat() }),
    },
    week: {
      label: i18n.t('last7Days'),
      value: '7',
      offset: 2,
      phrase: (date) => i18n.t('periodPhrase', { start: date, end: dateFormat() }),
    },
  }


  const [currentPage, setCurrentPage] = useState(0)
  const [periodSelected, setPeriodSelected] = useState(PERIODS.begin)

  const { data: resumeData } = useGetResume(periodSelected.value)
  const {
    data: detailData,
    isError: isDetailError,
    isLoading: isLoadingDetail
  } = useGetDetail({
    daysFrom: periodSelected.value,
    page: currentPage
  })


  const listContent = detailData?.contentStats || []

  const { isOnline } = useNetwork()
  const { isCreatorsSerieViewEnabled } = useFlags()


  const dayFrom = resumeData?.dayFrom
    ? periodSelected.value === PERIODS.begin.value
      ? resumeData?.dayFrom
      : dateFormat(resumeData?.dayFrom)
    : '--/--/----'

  const earnings = formatAmount(resumeData?.earnings)

  const followers = periodSelected.label === PERIODS.begin.label
    ? resumeData?.totalFollowers || 0
    : resumeData?.followers || 0

  const soldQuantity = parseInt(resumeData?.soldQuantity) || 0

  const handleFieldAndOrder = (field) => {
    if (orderField === field) {
      const direction = orderDirection === ORDER.asc
        ? ORDER.desc
        : ORDER.asc
      setOrderDirection(direction)

    } else {
      setOrderField(field)
      setOrderDirection(ORDER.asc)
    }
  }

  const getSortedList = (currentList) => {

    let sortFn = (a, b) => {
      const [first, last] = orderDirection === ORDER.asc ? [a, b] : [b, a]
      return first.releaseDate.localeCompare(last.releaseDate)
    }

    if (orderField === FIELD.title) {
      sortFn = (a, b) => {
        const [first, last] = orderDirection === ORDER.asc ? [a, b] : [b, a]
        return (first.serieTitle || first.title).localeCompare(last.serieTitle || last.title)
          || first.seasonNumber?.toString()?.localeCompare(last.seasonNumber?.toString())
          || first.order?.toString()?.localeCompare(last.order?.toString())
          || first.title.localeCompare(last.title)
      }
    }

    if (orderField === FIELD.purchases) {
      sortFn = (a, b) => {
        const [first, last] = orderDirection === ORDER.asc ? [a, b] : [b, a]
        return first.purchases.toString().localeCompare(
          last.purchases.toString(),
          undefined,
          { numeric: true }
        )
      }
    }

    if (orderField === FIELD.price) {
      sortFn = (a, b) => {
        const [first, last] = orderDirection === ORDER.asc ? [a, b] : [b, a]
        return first.price.localeCompare(
          last.price,
          undefined,
          { numeric: true }
        )
      }
    }

    if (orderField === FIELD.earnings) {
      sortFn = (a, b) => {
        const [first, last] = orderDirection === ORDER.asc ? [a, b] : [b, a]

        return first.earnings.localeCompare(
          last.earnings,
          undefined,
          { numeric: true }
        )
      }
    }

    if (orderField === FIELD.status) {
      sortFn = (a, b) => {
        const [first, last] = orderDirection === ORDER.asc ? [a, b] : [b, a]

        return first.status.toString().localeCompare(
          last.status.toString(),
          undefined,
          { numeric: true }
        )
      }
    }

    const newList = [...currentList]
    return newList.sort(sortFn)
  }

  const headerProps = {
    length: list.length,
    field: orderField,
    direction: orderDirection,
    onClick: handleFieldAndOrder
  }

  const headers = isSeriesView
    ? getSeriesHeaders(headerProps)
    : getContentHeaders(headerProps)

  const clearSearchValue = () => setSearchValue('')

  const handleChangePage = (page) => setCurrentPage(page)

  const getError = () => {
    if (searchValue && !list.length) return {
      icon: NoSearchResultsSVG,
      title: t('noSearchResults'),
      description: t('noSearchResultsDescription'),
    }

    if (!listContent.length) return {
      icon: NoContentSVG,
      title: t('noContentYet'),
      // description: t('noContentYetDescription')
    }
  }


  /**
   * On data loaded it prepares listSeries to show it on series view
   * and set the current list
   */
  useEffect(() => {
    if (!listContent.length) return
    if (!isCreatorsSerieViewEnabled) return

    const seriesTitles = new Set(listContent.map(item => item.serieTitle));

    const series = []

    seriesTitles.forEach(title => {
      if (!title) return

      const contentBySerie = listContent.filter(item => item.serieTitle === title)

      const uuid = contentBySerie[0].serieUUID

      const cover = contentBySerie.find(ep => ep.order === 0)?.cover

      const allReleaseDates = new Set(contentBySerie.map(item => item.releaseDate))
      const sortedReleaseDates = Array.from(allReleaseDates).sort((a, b) => b.localeCompare(a))
      const releaseDate = sortedReleaseDates[0]

      const allPurchases = contentBySerie.map(item => item.purchases)
      const purchases = allPurchases.reduce((partialSum, value) => partialSum + value, 0);

      const allEarnings = contentBySerie.map(item => item.earnings)

      const earnings = allEarnings.reduce((partialSum, value) => partialSum + parseFloat(value), 0);

      series.push({
        uuid,
        title,
        cover,
        releaseDate,
        purchases,
        earnings: earnings.toString()
      })
    })

    setListSeries(series)

    const currentList = isSeriesView ? series : listContent
    setList(currentList)
  }, [listContent])

  /**
   * On change the view it updates the list
   */
  useEffect(() => {
    if (!isCreatorsSerieViewEnabled) return

    setOrderDirection(ORDER.desc)
    setOrderField(FIELD.releaseDate)

    if (isSeriesView) setList(listSeries)
    else setList(listContent)
  }, [view])

  /**
   * On change the order field or order direction updates the list
   */
  useEffect(() => {
    const newList = getSortedList(list);
    setList(newList)
  }, [orderField, orderDirection])

  /**
   * On clear search value set all content in the list
   */
  useEffect(() => {
    if (searchValue) return

    const newList = getSortedList(
      isSeriesView ? listSeries : listContent
    );

    setList(newList)
  }, [searchValue])

  /**
   * On change search value filters content
   */
  useEffect(() => {
    if (!searchValue) return

    const filter = (item) => {
      const itemTitle = normalize(item.title.toLowerCase())
      const itemSerieTitle = normalize(item.serieTitle?.toLowerCase())
      const search = normalize(searchValue.toLowerCase())

      return itemTitle.includes(search) || itemSerieTitle.includes(search)
    }

    const currentList = isSeriesView ? listSeries : listContent
    const filteredList = [...currentList].filter(filter)

    // Sort in every change maybe isn't good for performance, but it works for now 😅
    const newList = getSortedList(filteredList)

    setList(newList)

  }, [searchValue, view])


  if (!isOnline) return (
    <ErrorCardContainer>
      <ErrorCard
        icon={NoInternetSVG}
        title={t('noInternet')}
        description={t('noInternetDescription')}
        isRefresh
      />
    </ErrorCardContainer>
  )

  if (isDetailError) return (
    <ErrorCardContainer>
      <ErrorCard
        icon={ServerErrorSVG}
        title={t('serverError')}
        description={t('serverErrorDescription')}
        isRefresh
      />
    </ErrorCardContainer>
  )

  return (
    <>
      <Seo title='Creators' />

      <FilterByDaysWrapper>
        <div>
          <Inter28>{t('statistics')}</Inter28>
          {periodSelected.phrase(dayFrom)}
        </div>
        <ButtonSelector
          selected={periodSelected}
          onChange={setPeriodSelected}
          options={Object.values(PERIODS)}
        />
      </FilterByDaysWrapper>

      <StatsWrapper>
        <Stat icon={followersIcon}>
          <h3>{t('newFollowers')}</h3>
          <p>{followers}</p>
        </Stat>
        <Stat icon={purchasesIcon}>
          <h3>{t('purchases')}</h3>
          <p>{soldQuantity}</p>
        </Stat>
        <Stat icon={earningsIcon}>
          <h3>{t('earnings')}</h3>
          <p>
            <FlixxCurrency />
            {earnings}
          </p>
        </Stat>
      </StatsWrapper>

      <ListWrapper>
        <ListFilters>
          <InputOld
            id='search'
            name='search'
            placeholder={t('searchYourVideo')}
            renderIcon={Magnifier}
            value={searchValue}
            onChange={setSearchValue}
            onClear={clearSearchValue}
          />

          {isCreatorsSerieViewEnabled && (
            <ViewSelectorWrapper>
              {t('creators:seeViewBy')}
              
              {/**
               *  'creators' variant doesnt exist,
               *  pass anything to avoid match with primary
               */}
              <Input.Select
                variant='creators'
                options={VIEW_OPTIONS}
                selected={view}
                onChange={setView}
                isSearchable={false}
              />
            </ViewSelectorWrapper>
          )}
        </ListFilters>

        <Table
          currentPage={currentPage}
          totalResults={list.length}
          resultsPerPage={1000000}
          onChangePage={handleChangePage}
          headers={headers}
          error={getError()}
          isLoading={isLoadingDetail}
        >
          {({ isInnerScrolling }) => {

            if (isSeriesView) return (
              list.map(serie => (
                <RowSerie
                  key={serie.uuid}
                  uuid={serie.uuid}
                  cover={serie.cover}
                  title={serie.title}
                  releaseDate={serie.releaseDate}
                  purchases={serie.purchases}
                  earnings={serie.earnings}
                  isShutDown={isInnerScrolling}
                />
              ))
            )

            return (
              list.map(content => (
                <RowContent
                  key={content.uuid}
                  uuid={content.uuid}
                  serieUUID={content.serieUUID}
                  cover={content.cover}
                  title={content.title}
                  serieTitle={content.serieTitle}
                  seasonNumber={content.seasonNumber}
                  episodeNumber={content.order + 1}
                  isSerie={content.contentType === 2}
                  status={content.status}
                  releaseDate={content.releaseDate}
                  purchases={content.purchases}
                  price={content.price}
                  earnings={content.earnings}
                  isShutDown={isInnerScrolling}
                />
              ))
            )

          }}
        </Table>
      </ListWrapper>
    </>
  )
}

export default Creators;